// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import assessment from './assessment'
import appUsers from './appUsers'

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  assessment,
  appUsers
})

export default rootReducer
